var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "b2ed1cc7fd209ec138e17d4633b03843c7404b0b"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-site@roadie"] = {
  id: "b2ed1cc7fd209ec138e17d4633b03843c7404b0b"
};